<div class="ipprintheader">
  <div class="card">
    <div class="card-header text-align-center padding-left-0px border-bot-1px">
      <div class="col-print-12 padding-left-0px">
        <div class="row margin-left-0px">
          <div class="col-print-1 padding-right-30px">
            <img src="garbhagudilogo(small).png" class="user-image-circle-65px img2 margin-top-15px">
          </div>
          
          <div class="col-print-7">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family13px">Corporate Office</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">Kalyani Nagar Branch,</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal">#26,Patalamma Temple Street,</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal">Near Metro Station,</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal">Bengaluru.</label>
            </div>

          </div>
          <div class="col-print-4">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family13px">Contact Details</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal"><i class="fas fa-phone"></i> : 0877-224531</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal"><i class="fas fa-envelope"></i> : garbagudi&#64;healins.com</label>
            </div>

          </div>

        </div>
      </div>
    </div>
    <div class="card-body padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px">
      <div class="row">
        <div class="col-print-11 text-align-center">
          <label class="margin-bottom-10px font-familyhead">IP Bill</label>
        </div>
      </div>

      <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
        <div class="row margin-left-0px">
          <div class="col-print-6 margin-top-10 margin-bottom-10px">
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Patient Name:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Referred By:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-6 margin-top-10 margin-bottom-10px">
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Bill Date:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Bill No:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>

          </div>
        </div>
      </div>



      <div class="col-print-12">
        <div class="row margin-left-0px">

          <div class="col-print-6 margin-top-10 margin-bottom-10px">
            <div class="row margin-left-0px">
              <div class="col-print-12">
                <label class="margin-bottom-0px font-familysubhead">Admission Details</label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Admission ID:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Admission Date:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Ward / Room:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Treating Doctor:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-normal">Admission Reason:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-6 margin-top-10 margin-bottom-10px">
            <div class="row margin-left-0px">
              <div class="col-print-12">
                <label class="margin-bottom-0px font-familysubhead">Discharge Details</label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Discharge Date:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">Approved By:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-normal">TPA / Card No:</label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
            

          </div>
        </div>
      </div>
    </div>

  </div>
</div>


